/* eslint-disable */
export default {
  onSearching: 'Ladataan...',
  noContacts: 'Tallenteita ei löytynyt.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
